import React, { useState, useEffect } from 'react'
import { checkGaurantorcoborrowerByUserId } from '../../AdminActionCreator.component'
import MainNavbar from './MainNavbar'
import MainEdit from './EditUserDetailsAllApplications/Main'
import TabBox from './TabBox'
import LoanDetails from './LoanDetails'
export default function Main({ ediDetailBackHandler, userDetails,admin }) {
    const [viewType, setviewType] = useState("borrower")
    const [subViewType, setSubViewType] = useState("list")
    const [checkTab, setcheckTab] = useState({})
    const [viewIngData, setViewingData] = useState([])

    useEffect(() => {
        checkGaurantorcoborrowerByUserIdFn(userDetails)
    }, [])

    const handleviewType = (type) => {
        setviewType(type)
        handleSubViewtype("list")
        if (type === "coBorrower") {
            setViewingData(checkTab?.coBorrowers)
        } else if (type === "gaurantor") {
            setViewingData(checkTab?.guarantors)
        } else {
            setViewingData([])
        }
    }

    const handleSubViewtype = (type)=>{
        setSubViewType(type)
    }

    const checkGaurantorcoborrowerByUserIdFn = (userDetails) => {
        checkGaurantorcoborrowerByUserId(userDetails?.userId, callback => {

            console.log("call", callback)
            if (callback?.status == 200 && callback?.message == "success") {
                setcheckTab(callback?.data)
            } else {
                setcheckTab({})
            }
        })
    }

    const handleBack = () => {
        if(subViewType == "details"){
            handleSubViewtype("list")
        }else{
            ediDetailBackHandler()
        }
    }


    return (
        <>
            <MainNavbar
                handleBack={handleBack}
                allData={userDetails}
                viewType={viewType}
                handleviewType={handleviewType}
                checkTab={checkTab}
            />

            {
                viewType === "borrower" ?
                    <MainEdit
                        userDetails={userDetails}
                        viewType={viewType}
                    />
                    : ''}
            {
                viewType === "loanDetails" ?
                    <LoanDetails
                        userDetails={userDetails}
                    />
                    : ''}

            {
                viewType === "coBorrower" || viewType == "gaurantor" ?
                    <TabBox
                    subViewType={subViewType}
                        handleSubViewtype={handleSubViewtype}
                        viewIngData={viewIngData}
                        viewType={viewType}
                        admin={admin}
                    />
                    : ''}
        </>
    )
}
